import { ControlItems, ListItemControlItems } from '../types/types';

// Type guard: narrows ControlItems to the listItem variant (options read from the GET/DEFAULT response)
export const isListItemControlItems = (
  items: ControlItems
): items is ListItemControlItems => {
  return (
    items !== null &&
    typeof items === 'object' &&
    !Array.isArray(items) &&
    'listItem' in items
  );
};
